"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _isArray = _interopRequireDefault(require("lodash/isArray"));

function _default(uri, options) {
  try {
    var body = JSON.parse(options.body);
    if ((0, _isArray["default"])(body)) return uri;
    var operationName = body.operationName;
    return "".concat(uri, "?operationName=").concat(operationName);
  } catch (error) {
    return uri;
  }
}